import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { InfluentFlowSensorNodeModel } from './InfluentFlowSensorNodeModel';
import { InfluentFlowSensorNodeWidget } from './InfluentFlowSensorNodeWidget';

export class InfluentFlowSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.InfluentFlowSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new InfluentFlowSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <InfluentFlowSensorNodeWidget engine={this.engine} node={event.model} width={50} height={44} renderedOnMap />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
